export default __webpack_public_path__ + "static/media/profile-bg.aa316880.jpg";